import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  Upload,
  List,
  InputNumber,
} from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  HighlightOutlined,
  AppstoreAddOutlined,
  DownloadOutlined,
  UploadOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import { TextEditor } from "../../../components/textEditor";
import { RenderImage } from "./components/renderImage";
import { ItemList } from "../../../components/itemList";
const { Text } = Typography;

// STATUS
const options_tipo = [
  { value: 1, label: "Texto" },
  { value: 2, label: "Youtube Vídeo" },
  { value: 3, label: "Imagem" },
  { value: 4, label: "Arquivo PDF" },
];

export const TreinamentosCadMateriais = () => {
  const { id_grupo, id_modulo, id_curso } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);
  const [tipo, setTipo] = useState(null);
  const [html, setHtml] = useState("");

  // DADOS
  const [modulo, setModulo] = useState({});

  useEffect(() => {
    if (id_modulo > 0) {
      carregarModulo(id_modulo);
      listarMateriais(id_modulo);
    }
  }, [id_modulo]);

  // CARREGAR
  const carregarModulo = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_modulos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setModulo(response);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarMateriais = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_materiais/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      navigate("/treinamentos/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarMaterial = async (formulario) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("id_treinamentos_cad_modulos", formulario?.id_treinamentos_cad_modulos);
    formData.append("tipo", formulario?.tipo);
    formData.append("ordem", formulario?.ordem);

    switch (formulario?.tipo) {
      case 1:
        formData.append("html", formulario?.html);
        break;
      case 2:
        formData.append("video_link", formulario?.video_link);
        break;
      default:
        formData.append("file", formulario?.arquivo[0]?.originFileObj);
        break;
    }

    const api = await http("post", `v1/treinamentos_materiais/adicionar`, formData);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarMateriais(id_modulo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarMaterial = async (formulario) => {
    setLoading(true);

    const formData = new FormData();
    formData.append("id", formulario?.id);
    formData.append("id_treinamentos_cad_modulos", formulario?.id_treinamentos_cad_modulos);
    formData.append("tipo", formulario?.tipo);
    formData.append("ordem", formulario?.ordem);

    switch (formulario?.tipo) {
      case 1:
        formData.append("html", formulario?.html);
        break;
      case 2:
        formData.append("video_link", formulario?.video_link);
        break;
      default:
        formData.append("file", formulario?.arquivo[0]?.originFileObj);
        break;
    }

    const api = await http("post", `v1/treinamentos_materiais/alterar`, formData);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarMateriais(id_modulo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarMaterial = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_materiais/carregar/${id}`, []);

    if (api.statusCode === 200) {
      const response = api?.response?.data;

      setShowModal(true);
      resetForm();
      setHtml(response?.html);
      setTipo(response?.tipo);

      form.setFieldsValue({
        tipo: response.tipo,
        qtd_questoes: response.qtd_questoes,
        video_link: response.video_link,
        ordem: response.ordem,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR ARQUIVO
  const carregarMaterialArquivo = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_materiais/carregar_arquivo_base64/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;

      // DOWNLOAD FILE
      let a = document.createElement("a");
      a.href = "data:application/octet-stream;base64," + response?.file;
      a.download = response?.nome_arquivo;
      a.click();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarMaterial = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_materiais/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarMateriais(id_modulo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
    setTipo(null);
    setHtml("");
  };

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_treinamentos_cad_modulos = id_modulo;
    formulario.html = html;

    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarMaterial(formulario);
    } else {
      cadastrarMaterial(formulario);
    }
  };

  const formFile = (e) => {
    const isLt2M = e?.file?.size / 1024 / 1024 > 50000;
    if (isLt2M) {
      message.error("Tamanho não suportado, máximo 5MB!");
      return null;
    }

    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const dadosFilter = dados?.length > 0 ? dados : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Material
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="tipo" label="Tipo" rules={[{ required: true, message: "Selecione o tipo!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o tipo"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_tipo}
                  onChange={(e) => setTipo(e)}
                  value={tipo}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="ordem" label="Ordem" rules={[{ required: true, message: "Informe a ordem!" }]}>
                <InputNumber
                  min={0}
                  size="large"
                  step={1}
                  max={999}
                  disabled={loading}
                  placeholder="Informe a ordem!"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            {tipo === 1 && (
              <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
                <TextEditor disabled={loading} onEditorChange={(e) => setHtml(e)} value={html} />
              </Col>
            )}
            {tipo === 2 && (
              <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="video_link"
                  label="ID Youtube Vídeo"
                  rules={[{ required: true, message: "Digite o id!" }]}>
                  <Input size="large" disabled={loading} placeholder="Informe o id" />
                </Form.Item>
              </Col>
            )}

            {(tipo === 3 || tipo === 4) && (
              <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="arquivo"
                  label="Arquivo"
                  valuePropName="fileList"
                  getValueFromEvent={formFile}
                  rules={[{ required: true, message: "Adicione um arquivo!" }]}
                  multiple={false}>
                  <Upload
                    style={{ maxHeight: 300 }}
                    disabled={loading}
                    multiple={false}
                    accept={tipo === 3 ? "image/png, image/jpeg" : "application/pdf"}
                    beforeUpload={() => false}
                    maxCount={1}>
                    <Button size="large" icon={<UploadOutlined />}>
                      Click to Upload
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
            )}
          </Row>
        </Form>
      </Modal>
    );
  };

  // RENDER LIST
  const renderList = (item) => {
    if (item?.tipo === 1) {
      return <div className="content" dangerouslySetInnerHTML={{ __html: item?.html }} />;
    } else if (item?.tipo === 2) {
      return (
        <iframe
          style={{ width: "100%", border: 0, height: 500 }}
          src={`https://www.youtube-nocookie.com/embed/${item?.video_link}`}
          title="Vídeo Portal Colaborador"
          allowFullScreen
        />
      );
    } else if (item?.tipo === 3) {
      return <RenderImage idImagem={item?.id} />;
    } else if (item?.tipo === 4) {
      return (
        <ItemList
          leftComponent={
            <div className="item-collapse-icon">
              <FileTextOutlined style={{ fontSize: 22, color: "#60b565" }} />
            </div>
          }
          onClick={() => carregarMaterialArquivo(item?.id)}
          hoverable={true}
          rightComponent={<DownloadOutlined />}>
          <Space wrap size={10}>
            <Text strong>{item.nome_arquivo}</Text>
          </Space>
        </ItemList>
      );
    }
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Treinamentos & Desenvolvimento"
              onClickBack={() => navigate(`/treinamentos/grupos/cursos/${id_grupo}/modulos/${id_curso}`)}
            />
            <HeaderTitle
              title="Materiais"
              subtitle={
                <Text italic>
                  <AppstoreAddOutlined /> {modulo?.descricao ?? ""}
                </Text>
              }
              icon={<HighlightOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <List
                size="large"
                itemLayout="vertical"
                footer={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      size="large"
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                dataSource={dadosFilter}
                renderItem={(item) => (
                  <List.Item
                    actions={[
                      <Space direction="vertical">
                        <Text italic type="secondary">
                          Ordem: {item?.ordem}
                        </Text>
                        <Space.Compact>
                          <Tooltip title="Editar">
                            <Button
                              loading={loading}
                              onClick={() => carregarMaterial(item.id)}
                              icon={<EditOutlined />}
                            />
                          </Tooltip>
                          <Tooltip title="Excluir">
                            <Button
                              loading={loading}
                              icon={<DeleteOutlined />}
                              onClick={() => {
                                modal.confirm({
                                  title: "Deseja deletar este registro?",
                                  okText: "Sim",
                                  cancelText: "Cancelar",
                                  onOk() {
                                    deletarMaterial(item?.id);
                                  },
                                });
                              }}
                            />
                          </Tooltip>
                        </Space.Compact>
                      </Space>,
                    ]}>
                    {renderList(item)}
                  </List.Item>
                )}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
